import { odinClient } from "@/config/client"

type UpdateFlashcardRequest = {
  question: string
  answer: string
}

export interface UpdateFlashcardParams {
  id: string
  index: number
  payload: UpdateFlashcardRequest
}

export function update(params: UpdateFlashcardParams) {
  return odinClient.put(`/v1/activities/${params.id}/flashcard/${params.index}`, params.payload)
}
